import React, { useContext, useState, useEffect } from "react";
import * as DOC from "../../../configs/consts";
import CurrencyInput from "react-currency-input";
import { StateContext } from "../../../context/Context";
import { format, addBusinessDays } from "date-fns";
import api from "../../../services/api";
import formas_api from "../../../services/formas_pagamento.json";
import {
  criaPix,
  foiPagoAvista,
  iconSelector,
  moeda,
  Parcelador,
} from "../../../services/utils";

import Endereco from "../../../components/Endereco";
import BoletoApi from "../../../components/BoletoApi";
import { getBoletoApiAtivo } from "../../../services/cobranca";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBarcode,
  faBoxOpen,
  faCreditCard,
  faExchangeAlt,
  faFileSignature,
  faQrcode,
} from "@fortawesome/free-solid-svg-icons";
import { Gboleto } from "./styles";
import GeraPix from "../../../components/GeraPix";

export default function GeraCobrancas(props) {
  const { contrato, parcela, via, totais } = props;
  const context = useContext(StateContext);
  const [valBoleto, setValBoleto] = useState(null);
  const [showBoleto, setShowBoleto] = useState(false);
  const [showCartao, setShowCartao] = useState(false);
  const [boletoApiAtivo, setBoletoApiAtivo] = useState(false);
  const [boletoParcid, setBoletoParcid] = useState(null);

  const [linkPagamento, setLinkPagamento] = useState("#");
  const [forma, setForma] = useState(0);
  const [tipo, setTipo] = useState("Contrato");
  const [descAVista, setDescAVista] = useState(false);
  const [parcelasSelecionadas, setParcelasSelecionadas] = useState(1);
  const [parcelasDisponiveis, setParcelasDisponiveis] = useState(
    DOC.MAX_PARCELAS
  );
  const [showPix, setShowPix] = useState(false);
  const [dadosPix, setDadosPix] = useState([]);

  const [viewButton, setViewButton] = useState(false);
  const [viewForma, setViewForma] = useState(true);
  const [viewTipo, setViewTipo] = useState(false);
  const [viewInfos, setViewInfos] = useState(false);
  const [viewParcelas, setViewParcelas] = useState(false);

  const vencimento = addBusinessDays(new Date(), 5);
  // Endereço pendente = régua da API (a MESMA que o registro do boleto no BB
  // usa), exposta em /perfil/cadastro. O predicado antigo (`!AlRevEndereco`)
  // respondia "já revisou alguma vez?", não "está completo?" — quem veio do
  // autocadastro nasce sem endereço e o BB recusa o registro. Mantido como
  // fallback para a janela em que o front novo roda com a API antiga.
  const cadastro = context.state.cadastro || {};
  const showRevEndereco =
    cadastro.enderecoPendente !== undefined
      ? Boolean(cadastro.enderecoPendente)
      : Boolean(!cadastro.AlRevEndereco);
  const enderecoFaltando = cadastro.enderecoFaltando || [];
  const alunoRestrito = context.state.cadastro.AlRestrito;

  useEffect(() => {
    getBoletoApiAtivo().then(setBoletoApiAtivo);
    if (via === 2) {
      setBoletoParcid(parcela.parcid);
      setShowBoleto(true);
    }
  }, []);

  const handleChange = (event, maskedvalue, floatvalue) => {
    setValBoleto(floatvalue);
  };

  // Removido `montaBoleto`: montava o payload do boleto SEM REGISTRO para o
  // formulário que dava POST em mpag.bb.com.br. Esse caminho foi excluído em
  // 2026-08-16 (decisão do dono do produto). Todo boleto do portal agora é
  // registrado pela API de Cobrança do BB — quem faz isso é <BoletoApi/>, que
  // só precisa do parcid.

  const handleTrocarForma = (e) => {
    e.preventDefault();
    setViewForma(true);
    setViewTipo(false);
    setDescAVista(false);
    setParcelasSelecionadas(1);
    setValBoleto(null);
    setViewInfos(false);
    setViewButton(false);
    //setViewParcelas(false);
  };

  const handleForma = (forma) => {
    setForma(forma);
    setViewForma(false);
    setViewTipo(true);
  };

  const handleTipo = (tipo) => {
    setViewTipo(false);
    setTipo(tipo);
    setViewInfos(true);
    setViewButton(true);
    setViewParcelas(forma === 2 ? true : false);
  };

  const handleValor = (e, valor) => {
    e.preventDefault();
    setValBoleto(valor);
    setParcelasSelecionadas(1);
    setDescAVista(true);
  };

  const handleParcelaSelecionada = (e) => {
    e.preventDefault();
    setParcelasSelecionadas(e.target.value);
  };

  const handleSubmit = (e, forma) => {
    e.preventDefault();
    setViewButton(false);
    const data = {
      parcconta: contrato,
      parcvalor: valBoleto,
      parctipo: tipo,
      parcforma: forma,
      parctaxa: forma === 5 ? DOC.TAXA_BOLETO : 0,
      parctitulo: forma === 5 ? 1 : null,
      parcvencimento: format(vencimento, "yyyy-MM-dd"),
      parcdescavista: descAVista,
      parcdesconto: Number(descAVista ? totais.aprazo - totais.avista : 0),
      parcacrescimo: Number(
        forma === 2 &&
          parcelasSelecionadas >
            context.state.cadastro.AlFormDados.FormLimiteSemJuros
          ? (valBoleto / 100) * context.state.cadastro.AlFormDados.FormTaxa
          : 0
      ),
      parcadmin: "Portal",
      parcorigem: "Portal",
    };
    api.post(`pagamentos/novaparcela`, data).then((dados) => {
      if (!dados.data.error) {
        if (forma === 5) {
          setBoletoParcid(dados.data.parcid);
          setShowBoleto(true);
        } else if (forma === 6) {
          const pix =
            (context.state.cadastro && context.state.cadastro.pix) || {};
          const code = criaPix({
            chave: pix.chave,
            mensagem: `${tipo} ${
              tipo === "E-commerce" ? dados.data.parcvenda : dados.parcconta
            }`,
            titular: pix.titular,
            cidade: pix.cidade,
            transacao: `${dados.data.parcid}`,
            valor: dados.data.parcvalor,
          });
          api
            .post(`pagamentos/pix/${dados.data.parcid}`, { code: code })
            .then((dt) => {
              setDadosPix(dados.data);
              setShowPix(true);
            });
        } else {
          api
            .post(`pagamentos/linkCheckout`, {
              order: {
                financeiro: dados.data,
                parcelamento: { selecionado: parcelasSelecionadas },
              },
            })
            .then((dt) => {
              setLinkPagamento(dt.data.checkoutUrl);
              setShowCartao(true);
            });
        }
      }
    });
  };

  return (
    <Gboleto>
      <Endereco
        view={showRevEndereco && via === 1}
        notificacao="Você tem dados faltando em seu cadastro. Por favor complete estes dados antes de continuar."
      />
      {!showRevEndereco && via === 1 && (
        <form className="via-1">
          {viewForma && (
            <div id="menuForma">
              {!alunoRestrito ? (
                <button
                  className="icone-e-texto-vertical"
                  onClick={() => handleForma(2)}
                >
                  <FontAwesomeIcon icon={faCreditCard} /> Pagar com cartão
                </button>
              ) : null}
              <button
                className="icone-e-texto-vertical"
                onClick={() => handleForma(6)}
              >
                <FontAwesomeIcon icon={faQrcode} /> Pagar com pix
              </button>
              {boletoApiAtivo && !alunoRestrito ? (
                <button
                  className="icone-e-texto-vertical"
                  onClick={() => handleForma(5)}
                >
                  <FontAwesomeIcon icon={faBarcode} /> Pagar com boleto
                </button>
              ) : null}
            </div>
          )}

          {viewTipo && (
            <div id="menuTipo">
              <button
                className="icone-e-texto-vertical"
                onClick={() => handleTipo("Contrato")}
              >
                <FontAwesomeIcon icon={faFileSignature} /> Contrato
              </button>
              {totais.extras > 0 && (
                <button
                  className="icone-e-texto-vertical"
                  onClick={() => handleTipo("Extras")}
                >
                  <FontAwesomeIcon icon={faBoxOpen} /> Extras e Pacotes
                </button>
              )}
            </div>
          )}
          {showPix && (
            <GeraPix dados={dadosPix} onClick={(e) => e.stopPropagation()} />
          )}
          {viewInfos && !showPix && (
            <>
              {/* {!foiPagoAvista(context.state.financeiro[0].AlParcelas) &&
                tipo === "Contrato" && (
                  <div id="sugestoes_cartao">
                    <p className="instrucoes">Considere estas sugestões:</p>
                    <button
                      className="icone-e-texto"
                      onClick={(e) => handleValor(e, totais.avista)}
                    >
                      {iconSelector(forma, formas_api)} Pague{" "}
                      {moeda(totais.avista)} à vista e aproveite o desconto
                    </button>
                    ou
                  </div>
                )} */}
              <CurrencyInput
                placeholder="Defina um valor para fazer o pagamento"
                prefix="R$ "
                value={valBoleto}
                decimalSeparator=","
                thousandSeparator="."
                onChangeEvent={handleChange}
                disabled={descAVista}
              />

              {viewParcelas && forma === 2 && (
                <Parcelador
                  id="parcelas_cartao"
                  disabled={descAVista} //também funciona como flag para pagamento avista
                  defaultValue={parcelasSelecionadas}
                  total={valBoleto}
                  disponiveis={parcelasDisponiveis}
                  minimo={DOC.PARCELA_MINIMA}
                  prazo={{
                    data: context.state.cadastro.AlFormDados.FormData,
                    limiteCartao:
                      context.state.cadastro.AlFormDados.FormLimiteCartao,
                    juro: {
                      com: context.state.cadastro.AlFormDados.FormTaxa,
                      sem: context.state.cadastro.AlFormDados
                        .FormLimiteSemJuros,
                    },
                    avista: context.state.cadastro.AlFormDados.FormValor, //sem uso, por enquanto
                    aprazo: context.state.cadastro.AlFormDados.FormValorPrazo, //sem uso, por enquanto
                  }}
                  onChange={(e) => handleParcelaSelecionada(e)}
                />
              )}

              <p className="instrucoes">
                - O valor mínimo é {moeda(DOC.PARCELA_MINIMA)}.
                <br />- Não é necessário o envio do comprovante de pagamento à
                Produtora.
                {forma === 2 && (
                  <>
                    <br />- Tenha em mãos os dados de seu cartão.
                    <br />- Você será redirecionado ao ambiente seguro da
                    operadora para preencher os dados.
                  </>
                )}
                {forma === 5 && (
                  <>
                    <br />- O boleto é registrado no banco na hora; a linha
                    digitável aparece aqui mesmo.
                    <br />- O valor gerado será acrescido da taxa bancária.
                    <br />- O prazo de pagamento é 5 dias à partir da geração.
                    <br />- A compensação do boleto é automática e pode levar
                    até 72hs.
                  </>
                )}
                {forma === 6 && (
                  <>
                    <br />- A confirmação do pix é manual e pode levar até 72hs.
                    <br />- Enviar o comprovante ã produtora agiliza o processo
                    de liberação.
                  </>
                )}
              </p>
            </>
          )}
          {viewButton && !showPix && (
            <>
              <button
                className="icone-e-texto"
                style={{ marginBottom: "10px", padding: "20px" }}
                disabled={valBoleto >= DOC.PARCELA_MINIMA ? "" : "disabled"}
                onClick={(e) => handleSubmit(e, forma)}
              >
                {iconSelector(forma, formas_api)} Pagar com{" "}
                {formas_api[forma].forma} agora
              </button>
              <button
                className="icone-e-texto"
                style={{ marginBottom: "10px", padding: "20px" }}
                onClick={(e) => handleTrocarForma(e)}
              >
                <FontAwesomeIcon icon={faExchangeAlt} /> Escolher outra opção
              </button>
            </>
          )}
        </form>
      )}

      {showBoleto && (
        <BoletoApi
          parcid={boletoParcid}
          via={via}
          // endereço só trava a EMISSÃO (o BB exige o pagador no registro).
          // Boleto já registrado é 2ª via de um título que existe: reexibir a
          // linha digitável não fala com o banco, então não pede cadastro.
          showRevEndereco={
            showRevEndereco && !(parcela && parcela.parclinhadigitavel)
          }
          faltando={enderecoFaltando}
        />
      )}

      {showCartao && (
        <a id="pagCartao" href={linkPagamento} className="icone-e-texto">
          <FontAwesomeIcon icon={faCreditCard} />
          EFETUAR PAGAMENTO
        </a>
      )}
    </Gboleto>
  );
}
